import type { RouteRecordRaw } from 'vue-router'

const gdprRoutes: RouteRecordRaw[] = [
  {
    path: 'confirm-storage/:slug',
    name: 'confirmStorage',
    component: () => import('@/v2/pages/gdpr/ConfirmStoragePage.vue'),
    meta: {
      layout: 'empty',
      requiresAuth: false
    }
  },
  {
    path: 'profile-deleted',
    name: 'profileDeleted',
    component: () => import('@/v2/pages/gdpr/ProfileDeletedPage.vue'),
    meta: {
      layout: 'empty',
      requiresAuth: false
    }
  }
]

export default gdprRoutes
